// extracted by mini-css-extract-plugin
export default {"cards":"ActivityCards_cards__MXtb1","content":"ActivityCards_content__jQ8SP","dateLabel":"ActivityCards_dateLabel__bAmRP"};